export const styles = {
  conatainer: {
    paddingTop: 60,
    paddingBottom: 60,
    background: '#F5F5F5'
  },
  workingSpaceImg: {
    width: 150,
    height: '100%',
    marginBottom: '-100%'
  },
  section: {
    background: 'white',
    border: '1px solid rgba(153,153,153,0.30)',
    boxShadow: '0 5px 10px 0 rgba(5,109,196,0.10)',
    borderRadius: 5,
    minHeight: 480,
    marginTop: 60,
    display: 'flex',
    flexDirection: 'column',
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 400,
    color: '#2F3755',
    fontSize: 18,
    lineHeight: '28px',
    '& > h2': {
      fontSize: 30,
      lineHeight: '41px',
      fontWeight: 700
    },
    '& > p': {
      flex: 2,
      marginBottom: 0
    },
    '& > p.textSmall': {
      fontSize: 14,
      marginBottom: 0,
      marginTop: 60
    },
    '@media (max-width: 767px)': {
      marginTop: 0
    }
  },
  padding: {
    padding: 40
  },
  xsHide: {
    display: 'defaut',
    '@media (max-width: 767px)': {
      display: 'none'
    }
  }
}



// WEBPACK FOOTER //
// ./src/layouts/Styles/TextImageSection.Style.js